import React, {useEffect, useState} from 'react';
import wrap from 'wraptile';
import {useHistory, useParams} from 'react-router-dom';
import {CircularProgress, Paper} from '@material-ui/core';
import Table, {
    getInitialPage,
    getInitialRowsPerPage,
    getInitialSort,
    Sort,
} from '@pluto/table';
import handleUnmount from '@pluto/handle-unmount';
import useQuery from '@pluto/query-hook';
import {setQuery} from '@pluto/set-history-query';
import {handleSort, handlePaging} from '@pluto/handlers';
import {TableVariants} from '@pluto/table';
import {baseRoutes} from 'App/AppRouter/routes';
import {
    MediaOrdersItemStateType,
    MediaOrdersItemSortParams,
    WorkflowStateType,
} from '../MediaOrdersTypes';
import {tableColumns} from './MediaOrdersItemColumn';
import './MediaOrderItem.scss';

// export const filterIds = curry((params, item) => {
//     return item !== params.mediaOrderItemId;
// });
//
// export const restoreMediaOrderItem = wrap(async ({restoreItem, setRemovedIds, removedIds}:any, params: any) => {
//     const {
//         mediaOrderId,
//         mediaOrderItemId,
//     } = params;
//     const {payload} = await restoreItem({
//         mediaOrderId,
//         mediaOrderItemId,
//     });
//
//     if (payload.type === 'success') {
//         setRemovedIds(removedIds.filter(filterIds({
//             mediaOrderId,
//             mediaOrderItemId,
//         })));
//     }
// });
//
// export const deleteMediaOrderItem = wrap(async ({deleteItem, setRemovedIds, removedIds}:any, params: any) => {
//     const {
//         mediaOrderId,
//         mediaOrderItemId,
//     } = params;
//     const {payload} = await deleteItem({
//         mediaOrderId,
//         mediaOrderItemId,
//     });
//
//     if (payload.type === 'success')
//         setRemovedIds([
//             ...removedIds,
//             mediaOrderItemId,
//         ]);
// });
//
// export const renderRestoreOrDeleteIcon = curry(({deleteItem, restoreItem, removedIds, setRemovedIds, mediaOrderId}, {id}) => {
//     const params = {
//         mediaOrderId,
//         mediaOrderItemId: id,
//     };
//
//     if (removedIds.includes(id))
//         return (
//             <Restore
//                 onClick={
//                     restoreMediaOrderItem({
//                         restoreItem,
//                         setRemovedIds,
//                         removedIds,
//                     }, params)
//                 }
//             />
//         );
//
//     return (
//         <CancelIcon
//             onClick={
//                 deleteMediaOrderItem({
//                     deleteItem,
//                     setRemovedIds,
//                     removedIds,
//                 }, params)
//             }
//         />
//     );
// });

interface onEffectProps {
    setItem: Function;
    id: string;
    params: MediaOrdersItemSortParams;
}

const onEffect = wrap(({setItem, params}: onEffectProps) => {
    setItem(params);
});

interface Props {
    mediaOrdersItem: MediaOrdersItemStateType;
    setItem: Function;
    setSorted: Function;
    resetItem: Function;
    workflowState: WorkflowStateType;
}

export default function MediaOrdersItemContainer(props: Props) {
    const {
        mediaOrdersItem,
        setSorted,
        resetItem,
        // setItem,
        // deleteItem,
        // restoreItem,
        workflowState,
    } = props;
    const {id} = useParams<{id: string}>();
    const query = useQuery();
    const initialRowsPerPage = getInitialRowsPerPage(query);
    const [rowsPerPage, setRowsPerPage] = useState<number>(initialRowsPerPage);
    const initialPage = getInitialPage({
        query,
        rowsPerPage,
    });
    const history = useHistory();
    const [page, setPage] = useState<number>(initialPage);
    const initialSort = getInitialSort(query);
    const [sort, setSort] = useState<Sort>(initialSort);
    // const [removedIds, setRemovedIds] = useState([]);

    const route = `${baseRoutes.mediaOrders}/${id}`;

    const params: MediaOrdersItemSortParams = {
        ...sort,
        offset: rowsPerPage * page,
        limit: rowsPerPage,
    };

    const handleSorted = (id: string) => (params: MediaOrdersItemSortParams) =>
        setSorted(id, params);

    const fetchOrder = onEffect({
        setItem: handleSorted(id),
        params,
    });

    const onSort = handleSort({
        setSort,
        setList: handleSorted(id),
        params,
        setQuery,
        history,
        route,
    });

    useEffect(fetchOrder, []);

    const onUnmount = handleUnmount(resetItem);

    useEffect(onUnmount, []);

    const {rows, total} = mediaOrdersItem;

    const onPaging = handlePaging({
        ...sort,
        setList: handleSorted(id),
        setQuery,
        history,
        route,
    });

    if (total === null) return <CircularProgress />;

    return (
        <Paper className="media-order-list-item">
            <Table
                // removedIds={removedIds}
                total={total}
                data={rows}
                columns={tableColumns(workflowState)}
                onChangePageHandler={onPaging}
                sort={sort}
                setSort={onSort}
                page={page}
                setPage={setPage}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                variant={TableVariants.scrollable}
            />
        </Paper>
    );
}
